import { Box, Divider, Stack } from '@mui/material'

import AutocompleteInput from 'components/shared/textFields/AutocompleteInput'
import { useGetCameraList } from 'hook/query/useGetCameraList'
import { useGetDailyShifts } from 'hook/query/useGetDailyShifts'
import { ShiftOptions } from 'models/ICattlesData'
import { CameraType } from 'models/IFrameInfo'
import { Moment } from 'moment'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ButtonUI } from 'ui/buttons/ButtonUI'
import { OutlinedButton } from 'ui/buttons/OutlinedButton'
import { CardStandart } from 'ui/CardStandart'

import DatePicker from 'ui/DatePickerInput/DatePicker'
import { DateRestriction } from 'ui/DatePickerInput/types'
import ExitWarningModal from 'ui/modal/ExitWarningModal'
import Preloader from 'ui/Preloader'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import { IdentificationState } from '../../DigitizationPage'
import { useFinishedIdentification } from './hook/useFinishedIdentifications'

interface IdentificationTableHeadProps {
	isRealIdent: boolean
	state: IdentificationState
	setState: React.Dispatch<
		React.SetStateAction<{
			gate: number[]
			date: number
			shift: ShiftOptions
			isDirty: boolean
		}>
	>
}

export const IdentificationTableHead = (
	props: IdentificationTableHeadProps,
) => {
	const { state, setState, isRealIdent } = props
	const [isFinishIndentModal, setIsFinishIdentModal] = useState<boolean>(false)
	const { mutate, isPending } = useFinishedIdentification()
	const navigate = useNavigate()
	const { data: availableShifts, isLoading: isLoadingShift } =
		useGetDailyShifts({ date: state.date, cameraId: state.gate[0] })
	const [shift, setShift] = useState([])
	const { data, isLoading } = useGetCameraList({
		type: CameraType.Identification,
	})

	// if (isLoading) {
	// 	return null
	// }
	const availableGates = data?.map(el => ({
		id: el.id,
		group: el.milking_hall,
		title: el.title,
	}))
	return (
		<CardStandart sx={{ padding: '24px' }}>
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: 'repeat(3, 1fr) 150px',
					gap: '24px',
					alignItems: 'center',
					width: '100%',
				}}
			>
				{availableGates && !isLoading && state.gate[0] && (
					<AutocompleteInput
						isError={false}
						widthForInput={'100%'}
						isDisable={false}
						variantSize='medium'
						onClick={id => {
							setState({ ...state, gate: [id], shift: undefined })
							setShift([])
						}}
						selectedValues={state.gate}
						availableList={availableGates}
						label={'Выберите вход'}
						loading={isLoading || !availableGates || !state.gate[0]}
						limitTags={1}
					/>
				)}

				{!isRealIdent && (
					<>
						<DatePicker
							value={state.date}
							variant='inputVariant'
							restrictionType={DateRestriction.PAST}
							daysRangeDisabled={14}
							onChange={(newDate: Moment | null) => {
								if (!newDate) return
								setState({
									...state,
									date: newDate.valueOf(),
									shift: undefined,
								})
								setShift([])
							}}
						/>

						<AutocompleteInput
							isError={false}
							widthForInput={'100%'}
							variantSize='medium'
							isDisable={false}
							onClick={id => {
								setShift([id])
								setState({ ...state, shift: availableShifts[id].value })
							}}
							selectedValues={shift}
							availableList={availableShifts}
							label={'Выберите смену'}
							loading={isLoadingShift}
							limitTags={1}
						/>

						<ButtonUI
							onClick={() => setIsFinishIdentModal(true)}
							width='100%'
							height={'56px'}
						>
							Завершить
						</ButtonUI>
					</>
				)}
			</Box>
			<Divider />
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: 'repeat(3, 1fr) 150px',
					gap: '24px',
					alignItems: 'center',
					width: '100%',
				}}
			>
				<Stack direction={'row'} alignItems={'center'} gap={'24px'}>
					<TypographySecondary14>№</TypographySecondary14>
					<TypographySecondary14>Статус</TypographySecondary14>
				</Stack>

				<TypographySecondary14>Номер ушной бирки SF</TypographySecondary14>

				<TypographySecondary14>
					Номер ушной бирки редактируемый
				</TypographySecondary14>

				<TypographySecondary14>Действие</TypographySecondary14>
			</Box>
			<ExitWarningModal
				open={isFinishIndentModal}
				onClose={() => setIsFinishIdentModal(false)}
				title={'Завершить оцифровку'}
				description={
					<>
						<span style={{ whiteSpace: 'nowrap' }}>
							После завершения оцифровки повторное изменение
						</span>
						<br />
						<span style={{ whiteSpace: 'nowrap' }}>
							отредактированных и подтвержденных номеров бирок будет невозможно.
						</span>
					</>
				}
				onSaveText={'Вернуться к редактированию'}
				onDismissText={'Завершить.'}
				saveButton={
					<OutlinedButton
						sx={{
							height: '54px',
						}}
						onClick={() => setIsFinishIdentModal(false)}
					>
						Вернуться к редактированию
					</OutlinedButton>
				}
				dismissButton={
					<ButtonUI
						onClick={() => {
							mutate(
								{
									day_period: state.shift,
									camera_id: state.gate[0],
									date: state.date,
								},
								{
									onSuccess: () => {
										setIsFinishIdentModal(false)
										navigate('/cattles')
									},
								},
							)
						}}
						sx={{ height: '54px' }}
					>
						{isPending ? <Preloader color='#fff' size={24} /> : 'Завершить'}
					</ButtonUI>
				}
			/>
		</CardStandart>
	)
}
